(function () {
  'use strict';

  var modal;
  var form;
  var lastFocus;
  var submitting = false;

  var topicMap = {
    'expert-help': 'Expert equipment help',
    equipment: 'Expert equipment help',
    parts: 'Parts & supplies',
    shipping: 'Order & shipping',
    order: 'Order & shipping',
    returns: 'Returns & warranty',
    warranty: 'Returns & warranty',
    b2b: 'B2B / bulk quote',
    quote: 'B2B / bulk quote',
    financing: 'Financing',
    documents: 'Product documents & manuals',
    'price-match': 'B2B / bulk quote',
    'part-match': 'Parts & supplies',
    'package-builder': 'Equipment package quote',
    'fit-check': 'Expert equipment help',
    'complete-package': 'Equipment package quote',
    'equipment-package': 'Equipment package quote',
    'equipment-finder': 'Expert equipment help',
    'equipment-advisor': 'Equipment package quote'
  };

  var docLabels = {
    'spec-sheet': 'spec sheet',
    manual: 'manual',
    'parts-list': 'parts list',
    'sell-sheet': 'sell sheet',
    warranty: 'warranty document'
  };

  function sanitize(value, maxLen) {
    if (window.TcbSecurity && typeof window.TcbSecurity.sanitizeQueryValue === 'function') {
      return window.TcbSecurity.sanitizeQueryValue(value, maxLen);
    }
    var text = String(value == null ? '' : value).trim();
    return typeof maxLen === 'number' && maxLen > 0 ? text.slice(0, maxLen) : text;
  }

  function rootScope() {
    return document.querySelector('[data-tcb-build]') || document.querySelector('.tcb-pro');
  }

  function isSafeContactHref(href) {
    if (!href) return false;
    if (window.TcbSecurity && typeof window.TcbSecurity.isSafeContactPath === 'function') {
      try {
        var url = new URL(href, window.location.origin);
        return window.TcbSecurity.isSafeContactPath(url.pathname + url.search + url.hash);
      } catch (e) {
        return false;
      }
    }
    return href.indexOf('/pages/contact') !== -1;
  }

  function field(id) {
    return document.getElementById(id);
  }

  function setTopic(value) {
    var select = field('tcb-modal-contact-topic');
    if (!select || !value) return;
    var normalized = sanitize(value, 64).toLowerCase();
    var mapped = topicMap[normalized] || value;
    var options = Array.prototype.slice.call(select.options);
    var match = options.find(function (opt) {
      return opt.value === mapped || opt.value.toLowerCase() === mapped.toLowerCase();
    });
    if (match) select.value = match.value;
  }

  function applyPackagePrefill(value) {
    if (!value) return;
    var ids = String(value)
      .split(/[,;|]/)
      .map(function (part) { return sanitize(part, 80).toLowerCase(); })
      .filter(Boolean);
    if (!ids.length) return;

    document.querySelectorAll('[data-tcb-contact-packages] [data-package-id]').forEach(function (input) {
      var id = (input.getAttribute('data-package-id') || '').toLowerCase();
      if (ids.indexOf(id) >= 0) input.checked = true;
    });

    if (window.TcbContactPackages && window.TcbContactPackages.updateSummary) {
      window.TcbContactPackages.updateSummary();
    }
  }

  function prefillFromHref(href) {
    if (!form) return;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    setTopic(url.searchParams.get('topic'));

    applyPackagePrefill(url.searchParams.get('package'));
    applyPackagePrefill(url.searchParams.get('packages'));

    var product = sanitize(url.searchParams.get('product'), 200);
    var productInput = field('tcb-modal-contact-product');
    if (productInput && product) productInput.value = product;

    var docParam = sanitize(url.searchParams.get('doc'), 64).toLowerCase();
    var messageInput = field('tcb-modal-contact-message');
    if (messageInput && docParam) {
      var label = docLabels[docParam] || docParam.replace(/-/g, ' ');
      messageInput.value = 'Please send the ' + label + ' for this product.';
    } else if (messageInput && product && !sanitize(messageInput.value, 5000)) {
      messageInput.placeholder = 'I have a question about ' + product + '…';
    }

    var part = sanitize(url.searchParams.get('part'), 120);
    if (part && messageInput && !docParam) {
      messageInput.value = 'I need help with part: ' + part + (product ? ' for ' + product : '') + '.';
    }
  }

  function resetFormState() {
    if (!form) return;
    form.querySelector('[data-tcb-contact-error]').hidden = true;
    form.querySelector('[data-tcb-contact-success]').hidden = true;
    form.querySelector('[data-tcb-contact-fields]').hidden = false;
    var submitBtn = form.querySelector('[data-tcb-contact-submit]');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send request';
    }
  }

  function showError(message) {
    var el = form.querySelector('[data-tcb-contact-error]');
    if (!el) return;
    el.textContent = message || 'Something went wrong. Please try again or call us.';
    el.hidden = false;
  }

  function showSuccess() {
    form.querySelector('[data-tcb-contact-error]').hidden = true;
    form.querySelector('[data-tcb-contact-fields]').hidden = true;
    form.querySelector('[data-tcb-contact-success]').hidden = false;
  }

  function openModal(href) {
    if (!modal || !form || !isSafeContactHref(href)) return false;
    lastFocus = document.activeElement;
    resetFormState();
    form.reset();
    prefillFromHref(href);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tcb-contact-modal-open');
    var firstInput = field('tcb-modal-contact-first') || modal.querySelector('.tcb-contact-modal__close');
    if (firstInput) firstInput.focus();
    return true;
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tcb-contact-modal-open');
    resetFormState();
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function shouldPopup(link) {
    if (!link || link.tagName !== 'A') return false;
    if (link.getAttribute('data-tcb-contact-fullpage') === 'true') return false;
    if (link.getAttribute('target') === '_blank') return false;
    var href = link.getAttribute('href') || '';
    if (href.indexOf('/pages/contact') === -1) return false;
    if (link.hasAttribute('data-tcb-contact-open')) return true;
    var scope = rootScope();
    return !!(scope && scope.contains(link));
  }

  function submitForm(event) {
    event.preventDefault();
    if (submitting || !form) return;

    var honeypot = field('tcb-modal-contact-hp');
    if (honeypot && honeypot.value.trim()) return;

    var first = field('tcb-modal-contact-first');
    var last = field('tcb-modal-contact-last');
    var fullName = field('tcb-modal-contact-full-name');
    if (fullName) {
      fullName.value = [first ? sanitize(first.value, 80) : '', last ? sanitize(last.value, 80) : '']
        .filter(Boolean)
        .join(' ');
    }

    var submitBtn = form.querySelector('[data-tcb-contact-submit]');
    submitting = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
    }

    fetch(form.action || '/contact', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html,application/xhtml+xml'
      }
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (
          html.indexOf('tcb-contact-alert--success') > -1 ||
          html.indexOf('tcb-contact-modal__alert--success') > -1 ||
          html.indexOf('Thanks — we') > -1 ||
          html.indexOf('form-success') > -1
        ) {
          if (window.tcbAnalytics) {
            var topicEl = field('tcb-modal-contact-topic');
            window.tcbAnalytics.quoteRequested('contact_modal', topicEl ? topicEl.value : '');
          }
          showSuccess();
          return;
        }
        if (html.indexOf('tcb-contact-alert--error') > -1 || html.indexOf('errors') > -1) {
          showError('Please check your entries and try again.');
          return;
        }
        if (window.tcbAnalytics) {
          var topicElFallback = field('tcb-modal-contact-topic');
          window.tcbAnalytics.quoteRequested('contact_modal', topicElFallback ? topicElFallback.value : '');
        }
        showSuccess();
      })
      .catch(function () {
        showError();
      })
      .finally(function () {
        submitting = false;
        var successEl = form.querySelector('[data-tcb-contact-success]');
        if (submitBtn && successEl && successEl.hidden) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send request';
        }
      });
  }

  function bindModal() {
    if (!modal || modal.getAttribute('data-tcb-contact-bound') === '1') return;
    modal.setAttribute('data-tcb-contact-bound', '1');
    form = document.getElementById('tcb-contact-modal-form');

    modal.querySelectorAll('[data-tcb-contact-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    if (form) {
      form.addEventListener('submit', submitForm);
    }
  }

  function bindTriggers() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="/pages/contact"], [data-tcb-contact-open]');
        if (!link || link.tagName !== 'A') return;
        if (!shouldPopup(link)) return;
        if (!openModal(link.href || link.getAttribute('href'))) return;
        e.preventDefault();
      },
      true
    );
  }

  function init() {
    modal = document.querySelector('[data-tcb-contact-modal]');
    bindModal();
    bindTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
